import { computed, signal, Injectable } from "@angular/core";
type CTAData = {
  url?: string;
  text?: string;
  total_price?: number;
};

@Injectable({
  providedIn: "root",
})
export class CtaService {
  public cta = signal<CTAData>({
    url: "",
    text: "",
    total_price: 0,
  });

  readonly ctaUrl = computed(() => {
    const url = this.cta().url?.trim() || "";
    return url ? (url.startsWith("http") ? url : `https://${url}`) : "";
  });

  public openCTA(): void {
    const url = this.ctaUrl();
    if (!url) return;

    const isEasyTipLink = url.includes("easytip");
    const finalUrl = isEasyTipLink
      ? `${url}?bill=${this.cta().total_price}`
      : url;
    window.open(finalUrl, "_blank");
  }
}
